import React from 'react'
import CurvedSideArrowSvg from './Svg/CurvedSideArrowSvg'
import { SxProps } from '@mui/system'

interface Props {
  doNotFlow?: boolean
  directionIsReversed?: boolean
  sx?: SxProps
}

const CurvedSideArrow: React.FC<Props> = ({ doNotFlow, directionIsReversed, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'
  const transform = 'translateX(-50%)'
  const combinedSx = { left: '50%', width: 'fit-content', ...sx }
  return <CurvedSideArrowSvg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg />
}

export default CurvedSideArrow
